<template>
    <div class="container">
        <Title>Hilfe-System</Title>


        <div class="search mb-5">
            <input type="text" v-model="query" class="search__input" placeholder="Suche…">
        </div>

        <div v-if="query" class="mb">
            <h2 class="mb-5">Suchergebnisse</h2>
            <DocumentList :documents="documents"></DocumentList>

        </div>
        <div v-else>
            <h2 class="mb-5">Relevante Dokumente</h2>
            <DocumentList :documents="documents"></DocumentList>
        </div>

    </div>
</template>

<script>
    import DocumentList from "../components/DocumentList.vue";
    import {DOCUMENTS_LOAD} from "../store/modules/documents";
    import {CATEGORIES_LOAD} from "../store/modules/categories";
    import Category from "../components/Category";
    import Title from "../ui/Title";
    import {SEARCH_QUERY_SET} from "../store/mutations";

    export default {
        name: "home",
        components: {
            Title,
            Category,
            DocumentList,
        },


        computed: {

            query: {
                set(v) {
                    this.$store.commit(SEARCH_QUERY_SET, v);
                },

                get() {
                    return this.$store.state.searchQuery;
                }
            },

            categories() {
                return this.$store.getters.categories;
            },

            documents() {
                return this.$store.getters.documents(this.query ? 'search' : 'context')
            }
        },

        watch: {
            query() {
                this.$store.dispatch(DOCUMENTS_LOAD, {
                    mode: 'search',
                    filter: {query: this.query}
                })
            }
        },

        mounted() {
            const params = new URLSearchParams(window.location.search);

            console.log('mounted!', window.location.search, params.get('url'));

            this.$store.dispatch(DOCUMENTS_LOAD, {
                mode: 'context',
                filter: {
                    url: params.get('url')
                }
            })

            setTimeout(() => {
                console.log('lolz!', window.location.search, params.get('url'));

            }, 100)
        }

    };
</script>

<style scoped>

    h2 {
        font-size: 2.2rem;
        line-height: 2.6rem;
        font-weight: normal;
        margin-bottom: 20px;
    }

    .search__input {
        display: block;
        width: 100%;

        padding: 1rem;
    }
</style>